/** Product identity — the one place the user-visible name lives (package names and code identifiers stay `keel`). */
export const BRAND = {
  name: 'Mintage',
  tagline: 'Money, well made',
  supportEmail: 'hello@mintagemoney.com',
  siteUrl: 'https://mintagemoney.com',
} as const;
